import { defineMessages } from 'react-intl';

export default defineMessages({
  dailyMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.dailyMessage',
    description: 'Message of daily scheduled pipeline',
    defaultMessage: 'Your pipeline will be scheduled between {utcRange} UTC',
  },
  weeklyMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.weeklyMessage',
    description: 'Message of weekly scheduled pipeline',
    defaultMessage:
      'Your pipeline will be scheduled on {utcDay} between {utcRange} UTC',
  },
  monthlyMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.monthlyMessage',
    description: 'Message of monthly scheduled pipeline',
    defaultMessage:
      'Your pipeline will be scheduled on the {daySuffix} of every month between {timeRange} UTC',
  },
  customMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.customMessage',
    description: 'Message of custom scheduled pipeline',
    defaultMessage:
      'Bitbucket uses the {quartzLink} cron syntax to schedule pipelines.',
  },
  quartzLinkMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.quartzLinkMessage',
    description: 'Message of quartz link',
    defaultMessage: 'Quartz',
  },
  customLabel: {
    id: 'frontbucket.pipelines.components.runPipeline.customLabel',
    description: 'Label of custom scheduled pipeline',
    defaultMessage: 'Cron pattern',
  },
  scheduleLabel: {
    id: 'frontbucket.pipelines.components.runPipeline.scheduleLabel',
    description: 'Label of scheduled pipeline section',
    defaultMessage: 'Schedule (Local time)',
  },
  errorMessage: {
    id: 'frontbucket.pipelines.components.runPipeline.errorMessage',
    description: 'error message of scheduled pipeline section',
    defaultMessage: '{message}',
  },
});
